import type { ReactNode } from "react";
import {
	DialogCloseButton,
	DialogContent,
	DialogTitle,
} from "#/components/ui/dialog";
import { cn } from "#/lib/utils";

type TradeDialogContentProps = {
	title: ReactNode;
	/** Width/style overrides merged onto the shared chrome (twMerge, last wins). */
	className?: string;
	children: ReactNode;
};

/**
 * Shared chrome for the positions-panel form dialogs (TP/SL edit, open-order
 * edit, limit close): gradient surface + title row with a close button.
 * Render inside a `Dialog`; pair with a `DialogTrigger`.
 */
export function TradeDialogContent({
	title,
	className,
	children,
}: TradeDialogContentProps) {
	return (
		<DialogContent
			className={cn(
				"w-[min(400px,calc(100vw-2rem))] rounded-[20px] border border-trade-border-subtle bg-[linear-gradient(180deg,var(--trade-surface-overlay),var(--trade-surface-overlay-end))] p-5 shadow-[inset_0_0_0_1px_rgba(255,255,255,0.03),0_30px_60px_rgba(0,0,0,0.45)]",
				className,
			)}
		>
			<div className="flex items-center justify-between">
				<DialogTitle className="text-body2-bold text-trade-text-strong">
					{title}
				</DialogTitle>
				<DialogCloseButton />
			</div>
			{children}
		</DialogContent>
	);
}
